// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"cf5d3c0d","171":"75498da2","429":"806b4a61","453":"a621bcce","546":"059d1c58"}[chunkId] + ".chunk.js";
};